import { AnalyticIdentifier } from '@common/neo.tax';

import { useAnalyticId } from '@neo.tax/shared';

type AccountingExpenseFormAnalyticIds = {
  nameAnalyticId: string;
  rdCategoryAnalyticId: string;
};

export const useAccountingExpenseFormAnalyticIds = (): AccountingExpenseFormAnalyticIds => ({
  nameAnalyticId: useAnalyticId(AnalyticIdentifier.ENTERPRISE_ACCOUNTING_QRE_TABLE_DETAIL_GENERAL_FORM_NAME),
  rdCategoryAnalyticId: useAnalyticId(
    AnalyticIdentifier.ENTERPRISE_ACCOUNTING_QRE_TABLE_DETAIL_GENERAL_FORM_RD_CATEGORY,
  ),
});
